import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const PartnerContainer = styled.div`
  margin-bottom: 30px;
  position: relative;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  background: ${(props) => props.theme.color.light.default};
  border: 1px solid ${(props) => props.theme.color.yellow.default};
  border-radius: 8px;
  padding: 16px;
  ${mediaQuery('tablet')} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
export const PartnerTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const PartnerTitle = styled.div`
  color: ${(props) => props.theme.color.yellow.default};
  font-size: 24px;
  font-weight: 700;
  line-height: 40px;
`;
